import { useState } from 'react'
import { useParams } from 'react-router'
import { PublicAppFooter } from '../PublicAppFooter'
import PublicAppHeader from '../PublicAppHeader'
import { ClubbedAuthModal } from '../SignIn/ClubbedAuthComponents'
import { INITAL_CLUBBED_AUTH_MODAL_BASIC_DETAILS_STATE } from '../SignIn/ClubbedAuthComponents/utils'
import EmailVerifyContent from './components/EmailVerifyContent'

export default function EmailVerify() {
  const { token } = useParams()
  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('signup')

  function goToLogin() {
    setTypeOfClubbedAuthModal('login')
    setShowClubbedAuthModal(true)
  }

  function goToRegister() {
    setTypeOfClubbedAuthModal('signup')
    setShowClubbedAuthModal(true)
  }

  return (
    <>
      <PublicAppHeader loginFunction={goToLogin} registerFunction={goToRegister} />
      <ClubbedAuthModal
        open={showClubbedAuthModal}
        onClose={() => setShowClubbedAuthModal(false)}
        loginVariant={typeOfClubbedAuthModal === 'login'}
        nameFieldHeading={'Your Name'}
        initialOnboardingDetails={{ ...INITAL_CLUBBED_AUTH_MODAL_BASIC_DETAILS_STATE }}
      />
      <EmailVerifyContent token={token} goToLoginButton={goToLogin} />
      <PublicAppFooter />
    </>
  )
}
